/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseBcReporting } from '../models/api-response-bc-reporting';
import { ApiResponseBoolean } from '../models/api-response-boolean';
import { ApiResponseBroadcast } from '../models/api-response-broadcast';
import { ApiResponseBroadcastDetailsResponse } from '../models/api-response-broadcast-details-response';
import { ApiResponsePagedResultBcDetails } from '../models/api-response-paged-result-bc-details';
import { ApiResponsePagedResultScheduledBroadcastResponse } from '../models/api-response-paged-result-scheduled-broadcast-response';
import { ApiResponseScheduledBroadcastResponse } from '../models/api-response-scheduled-broadcast-response';
import { createBroadcast } from '../fn/broadcast-api/create-broadcast';
import { CreateBroadcast$Params } from '../fn/broadcast-api/create-broadcast';
import { createMediaBroadcast } from '../fn/broadcast-api/create-media-broadcast';
import { CreateMediaBroadcast$Params } from '../fn/broadcast-api/create-media-broadcast';
import { deleteBroadcast } from '../fn/broadcast-api/delete-broadcast';
import { DeleteBroadcast$Params } from '../fn/broadcast-api/delete-broadcast';
import { exportBroadcastDetailsExcel } from '../fn/broadcast-api/export-broadcast-details-excel';
import { ExportBroadcastDetailsExcel$Params } from '../fn/broadcast-api/export-broadcast-details-excel';
import { exportBroadcastDetailsSearchExcel } from '../fn/broadcast-api/export-broadcast-details-search-excel';
import { ExportBroadcastDetailsSearchExcel$Params } from '../fn/broadcast-api/export-broadcast-details-search-excel';
import { exportBroadcastExcel } from '../fn/broadcast-api/export-broadcast-excel';
import { ExportBroadcastExcel$Params } from '../fn/broadcast-api/export-broadcast-excel';
import { forceRetryFailedMessages } from '../fn/broadcast-api/force-retry-failed-messages';
import { ForceRetryFailedMessages$Params } from '../fn/broadcast-api/force-retry-failed-messages';
import { getBroadcastByReference } from '../fn/broadcast-api/get-broadcast-by-reference';
import { GetBroadcastByReference$Params } from '../fn/broadcast-api/get-broadcast-by-reference';
import { getBroadcastDetailsByReference } from '../fn/broadcast-api/get-broadcast-details-by-reference';
import { GetBroadcastDetailsByReference$Params } from '../fn/broadcast-api/get-broadcast-details-by-reference';
import { reportingBroadcast } from '../fn/broadcast-api/reporting-broadcast';
import { ReportingBroadcast$Params } from '../fn/broadcast-api/reporting-broadcast';
import { reportingBroadcastByCompany } from '../fn/broadcast-api/reporting-broadcast-by-company';
import { ReportingBroadcastByCompany$Params } from '../fn/broadcast-api/reporting-broadcast-by-company';
import { reportingBroadcastForAll } from '../fn/broadcast-api/reporting-broadcast-for-all';
import { ReportingBroadcastForAll$Params } from '../fn/broadcast-api/reporting-broadcast-for-all';
import { searchScheduledBroadcast } from '../fn/broadcast-api/search-scheduled-broadcast';
import { SearchScheduledBroadcast$Params } from '../fn/broadcast-api/search-scheduled-broadcast';
import { updateBroadcast } from '../fn/broadcast-api/update-broadcast';
import { UpdateBroadcast$Params } from '../fn/broadcast-api/update-broadcast';
import { updateBroadcastScheduled } from '../fn/broadcast-api/update-broadcast-scheduled';
import { UpdateBroadcastScheduled$Params } from '../fn/broadcast-api/update-broadcast-scheduled';
import { updateMediaBroadcast } from '../fn/broadcast-api/update-media-broadcast';
import { UpdateMediaBroadcast$Params } from '../fn/broadcast-api/update-media-broadcast';
import { updateScheduledBroadcast } from '../fn/broadcast-api/update-scheduled-broadcast';
import { UpdateScheduledBroadcast$Params } from '../fn/broadcast-api/update-scheduled-broadcast';

@Injectable({ providedIn: 'root' })
export class BroadcastApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBroadcastByReference()` */
  static readonly GetBroadcastByReferencePath = '/v1/api/ui/broadcast/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBroadcastByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBroadcastByReference$Response(params: GetBroadcastByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcastDetailsResponse>> {
    return getBroadcastByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBroadcastByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBroadcastByReference(params: GetBroadcastByReference$Params, context?: HttpContext): Observable<ApiResponseBroadcastDetailsResponse> {
    return this.getBroadcastByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcastDetailsResponse>): ApiResponseBroadcastDetailsResponse => r.body)
    );
  }

  /** Path part for operation `updateScheduledBroadcast()` */
  static readonly UpdateScheduledBroadcastPath = '/v1/api/ui/broadcast/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateScheduledBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateScheduledBroadcast$Response(params: UpdateScheduledBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseScheduledBroadcastResponse>> {
    return updateScheduledBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateScheduledBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateScheduledBroadcast(params: UpdateScheduledBroadcast$Params, context?: HttpContext): Observable<ApiResponseScheduledBroadcastResponse> {
    return this.updateScheduledBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseScheduledBroadcastResponse>): ApiResponseScheduledBroadcastResponse => r.body)
    );
  }

  /** Path part for operation `deleteBroadcast()` */
  static readonly DeleteBroadcastPath = '/v1/api/ui/broadcast/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBroadcast()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBroadcast$Response(params: DeleteBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBroadcast$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBroadcast(params: DeleteBroadcast$Params, context?: HttpContext): Observable<void> {
    return this.deleteBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateBroadcast()` */
  static readonly UpdateBroadcastPath = '/v1/api/ui/broadcast/update/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBroadcast$Response(params: UpdateBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return updateBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBroadcast(params: UpdateBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.updateBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

  /** Path part for operation `updateMediaBroadcast()` */
  static readonly UpdateMediaBroadcastPath = '/v1/api/ui/broadcast/update/media/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMediaBroadcast()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMediaBroadcast$Response(params: UpdateMediaBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return updateMediaBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMediaBroadcast$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMediaBroadcast(params: UpdateMediaBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.updateMediaBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

  /** Path part for operation `createBroadcast()` */
  static readonly CreateBroadcastPath = '/v1/api/ui/broadcast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBroadcast$Response(params: CreateBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return createBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBroadcast(params: CreateBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.createBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

  /** Path part for operation `searchScheduledBroadcast()` */
  static readonly SearchScheduledBroadcastPath = '/v1/api/ui/broadcast/search-scheduled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchScheduledBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchScheduledBroadcast$Response(params: SearchScheduledBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultScheduledBroadcastResponse>> {
    return searchScheduledBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchScheduledBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchScheduledBroadcast(params: SearchScheduledBroadcast$Params, context?: HttpContext): Observable<ApiResponsePagedResultScheduledBroadcastResponse> {
    return this.searchScheduledBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultScheduledBroadcastResponse>): ApiResponsePagedResultScheduledBroadcastResponse => r.body)
    );
  }

  /** Path part for operation `updateBroadcastScheduled()` */
  static readonly UpdateBroadcastScheduledPath = '/v1/api/ui/broadcast/scheduled/update/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBroadcastScheduled()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBroadcastScheduled$Response(params: UpdateBroadcastScheduled$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBoolean>> {
    return updateBroadcastScheduled(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBroadcastScheduled$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBroadcastScheduled(params: UpdateBroadcastScheduled$Params, context?: HttpContext): Observable<ApiResponseBoolean> {
    return this.updateBroadcastScheduled$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBoolean>): ApiResponseBoolean => r.body)
    );
  }

  /** Path part for operation `reportingBroadcast()` */
  static readonly ReportingBroadcastPath = '/v1/api/ui/broadcast/reporting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportingBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcast$Response(params: ReportingBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBcReporting>> {
    return reportingBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportingBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcast(params: ReportingBroadcast$Params, context?: HttpContext): Observable<ApiResponseBcReporting> {
    return this.reportingBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBcReporting>): ApiResponseBcReporting => r.body)
    );
  }

  /** Path part for operation `reportingBroadcastByCompany()` */
  static readonly ReportingBroadcastByCompanyPath = '/v1/api/ui/broadcast/reporting/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportingBroadcastByCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcastByCompany$Response(params: ReportingBroadcastByCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBcReporting>> {
    return reportingBroadcastByCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportingBroadcastByCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcastByCompany(params: ReportingBroadcastByCompany$Params, context?: HttpContext): Observable<ApiResponseBcReporting> {
    return this.reportingBroadcastByCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBcReporting>): ApiResponseBcReporting => r.body)
    );
  }

  /** Path part for operation `exportBroadcastExcel()` */
  static readonly ExportBroadcastExcelPath = '/v1/api/ui/broadcast/reporting/export-excel/{lang}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportBroadcastExcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastExcel$Response(params: ExportBroadcastExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportBroadcastExcel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportBroadcastExcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastExcel(params: ExportBroadcastExcel$Params, context?: HttpContext): Observable<Blob> {
    return this.exportBroadcastExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportingBroadcastForAll()` */
  static readonly ReportingBroadcastForAllPath = '/v1/api/ui/broadcast/reporting/All';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportingBroadcastForAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcastForAll$Response(params: ReportingBroadcastForAll$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBcReporting>> {
    return reportingBroadcastForAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportingBroadcastForAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportingBroadcastForAll(params: ReportingBroadcastForAll$Params, context?: HttpContext): Observable<ApiResponseBcReporting> {
    return this.reportingBroadcastForAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBcReporting>): ApiResponseBcReporting => r.body)
    );
  }

  /** Path part for operation `createMediaBroadcast()` */
  static readonly CreateMediaBroadcastPath = '/v1/api/ui/broadcast/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMediaBroadcast()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMediaBroadcast$Response(params: CreateMediaBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return createMediaBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMediaBroadcast$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMediaBroadcast(params: CreateMediaBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.createMediaBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

  /** Path part for operation `forceRetryFailedMessages()` */
  static readonly ForceRetryFailedMessagesPath = '/v1/api/ui/broadcast/force-retry/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forceRetryFailedMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  forceRetryFailedMessages$Response(params: ForceRetryFailedMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBoolean>> {
    return forceRetryFailedMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forceRetryFailedMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  forceRetryFailedMessages(params: ForceRetryFailedMessages$Params, context?: HttpContext): Observable<ApiResponseBoolean> {
    return this.forceRetryFailedMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBoolean>): ApiResponseBoolean => r.body)
    );
  }

  /** Path part for operation `getBroadcastDetailsByReference()` */
  static readonly GetBroadcastDetailsByReferencePath = '/v1/api/ui/broadcast/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBroadcastDetailsByReference()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBroadcastDetailsByReference$Response(params: GetBroadcastDetailsByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultBcDetails>> {
    return getBroadcastDetailsByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBroadcastDetailsByReference$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBroadcastDetailsByReference(params: GetBroadcastDetailsByReference$Params, context?: HttpContext): Observable<ApiResponsePagedResultBcDetails> {
    return this.getBroadcastDetailsByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultBcDetails>): ApiResponsePagedResultBcDetails => r.body)
    );
  }

  /** Path part for operation `exportBroadcastDetailsExcel()` */
  static readonly ExportBroadcastDetailsExcelPath = '/v1/api/ui/broadcast/details/export-excel/{lang}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportBroadcastDetailsExcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastDetailsExcel$Response(params: ExportBroadcastDetailsExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportBroadcastDetailsExcel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportBroadcastDetailsExcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastDetailsExcel(params: ExportBroadcastDetailsExcel$Params, context?: HttpContext): Observable<Blob> {
    return this.exportBroadcastDetailsExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportBroadcastDetailsSearchExcel()` */
  static readonly ExportBroadcastDetailsSearchExcelPath = '/v1/api/ui/broadcast/details/export-excel-search/{lang}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportBroadcastDetailsSearchExcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastDetailsSearchExcel$Response(params: ExportBroadcastDetailsSearchExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportBroadcastDetailsSearchExcel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportBroadcastDetailsSearchExcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportBroadcastDetailsSearchExcel(params: ExportBroadcastDetailsSearchExcel$Params, context?: HttpContext): Observable<Blob> {
    return this.exportBroadcastDetailsSearchExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
